import styled from "styled-components";
import { AiOutlineTag } from "react-icons/ai";
import { Apartment } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import { Typography, Box, IconButton, Grid, Tooltip } from "@mui/material";

import useAxios from "../../hooks/useAxios";
import pages from "../../constants/pages";
import { useComponent } from "../../hooks";
import { colors } from "../css components/Style";
import { ComponentHeader, Loader, PageHeader } from "../../components";

const Wrapper = styled(Grid)`
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  position: relative;
`;

const PlatformName = styled(Typography)`
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const LogoWithName = styled.div`
  display: flex;
`;

const LogoContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 5px;
  margin-right: 12px;
`;

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple}!important;
  color: ${colors.purple}!important;
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple}!important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function PlatformTenants() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { loader } = useComponent();
  const [tenants, setTenants] = useState({});

  useEffect(() => {
    loader.start();
    axios({
      url: "/list/dynamicDashboard",
    }).then((res) => {
      if (res.status) {
        let tenantsList = {
          api: [],
          platform: [],
        };
        for (let tenant of res.data) {
          if (tenant.type === "Api") {
            tenantsList.api.push(tenant);
          }
          if (tenant.type === "Platform") {
            tenantsList.platform.push(tenant);
          }
        }
        setTenants(tenantsList);
      }
      loader.apiComplete();
    });
  }, [axios, loader]);

  return (
    <Fragment>
      <PageHeader pageName="Tenants" />
      <Loader>
        <Grid container spacing={4}>
          <Grid size={12}>
            <ComponentHeader title="Platform Tenants" />
          </Grid>

          {tenants?.platform?.map((tenant) => (
            <Wrapper
              size={4}
              onClick={() => {
                if (tenant.platform_association_type === "AGENCY") {
                  navigate(
                    pages.unverifiedAgenciesList.route +
                      "?platformID=" +
                      tenant.platform_id,
                    {
                      state: {
                        component: "platform",
                      },
                    }
                  );
                }

                if (tenant.platform_association_type === "BRAND") {
                  navigate(
                    pages.unverifiedPage.route +
                      "?platformID=" +
                      tenant.platform_id,
                    {
                      state: {
                        component: "platform",
                      },
                    }
                  );
                }
              }}
            >
              <LogoWithName>
                <LogoContainer>
                  {tenant.site_logo ? (
                    <img
                      src={tenant.site_logo}
                      alt={tenant.platform_name}
                      style={{ height: "auto", width: "inherit" }}
                    />
                  ) : (
                    <></>
                  )}
                </LogoContainer>
              </LogoWithName>

              <div>
                <PlatformName>{tenant.platform_name}</PlatformName>

                {(tenant.platform_association_type === "BRAND" ||
                  tenant.platform_association_type === "BOTH") && (
                  <Tooltip title="View Brands">
                    <Icon
                      onClick={() =>
                        navigate(
                          pages.unverifiedPage.route +
                            "?platformID=" +
                            tenant.platform_id,
                          {
                            state: {
                              component: "platform",
                            },
                          }
                        )
                      }
                    >
                      <AiOutlineTag />
                    </Icon>
                  </Tooltip>
                )}

                {(tenant.platform_association_type === "AGENCY" ||
                  tenant.platform_association_type === "BOTH") && (
                  <Tooltip title="View Agency">
                    <Icon
                      onClick={() =>
                        navigate(
                          pages.unverifiedAgenciesList.route +
                            "?platformID=" +
                            tenant.platform_id,
                          {
                            state: {
                              component: "platform",
                            },
                          }
                        )
                      }
                    >
                      <Apartment />
                    </Icon>
                  </Tooltip>
                )}
              </div>
            </Wrapper>
          ))}

          <Grid size={12}>
            <ComponentHeader title="API Tenants" />
          </Grid>

          {tenants?.api?.map((tenant) => (
            <Wrapper
              size={4}
              onClick={() => {
                if (tenant.platform_association_type === "AGENCY") {
                  navigate(
                    pages.unverifiedAgenciesList.route +
                      "?platformID=" +
                      tenant.platform_id,
                    {
                      state: {
                        component: "platform",
                      },
                    }
                  );
                }

                if (tenant.platform_association_type === "BRAND") {
                  navigate(
                    pages.unverifiedPage.route +
                      "?platformID=" +
                      tenant.platform_id,
                    {
                      state: {
                        component: "platform",
                      },
                    }
                  );
                }
              }}
            >
              <LogoWithName>
                <LogoContainer>
                  {tenant.site_logo ? (
                    <img
                      src={tenant.site_logo}
                      alt={tenant.platform_name}
                      style={{ height: "auto", width: "inherit" }}
                    />
                  ) : (
                    <></>
                  )}
                </LogoContainer>
              </LogoWithName>

              <div>
                <PlatformName>{tenant.platform_name}</PlatformName>

                {(tenant.platform_association_type === "BRAND" ||
                  tenant.platform_association_type === "BOTH") && (
                  <Tooltip title="View Brands">
                    <Icon
                      onClick={() =>
                        navigate(
                          pages.unverifiedPage.route +
                            "?platformID=" +
                            tenant.platform_id,
                          {
                            state: {
                              component: "platform",
                            },
                          }
                        )
                      }
                    >
                      <AiOutlineTag />
                    </Icon>
                  </Tooltip>
                )}

                {(tenant.platform_association_type === "AGENCY" ||
                  tenant.platform_association_type === "BOTH") && (
                  <Tooltip title="View Agency">
                    <Icon
                      onClick={() =>
                        navigate(
                          pages.unverifiedAgenciesList.route +
                            "?platformID=" +
                            tenant.platform_id,
                          {
                            state: {
                              component: "platform",
                            },
                          }
                        )
                      }
                    >
                      <Apartment />
                    </Icon>
                  </Tooltip>
                )}
              </div>
            </Wrapper>
          ))}
        </Grid>
      </Loader>
    </Fragment>
  );
}
